import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const GetTeamMyStoresQuery = gql`
  query MyTeamStoresList($limit: Int, $offset: Int) {
    myTeamstores(limit: $limit, offset: $offset) {
      teamStores {
        id
        shortId: short_id
        name
        banner
        closed
        imported
        passCode: passcode_raw
        isOnDemand: on_demand_mode
        fixedPrice: fixed_price
        createdAt: created_at
        gracePeriod: grace_period
        cutOffDateString
        deliveryDateString
        itemsCount
        totalOrders
        bulkShipOption: bulk_ship_option
        isMandatory: is_mandatory
        bulkShipFirstName: bulk_ship_first_name
        bulkShipLastName: bulk_ship_last_name
        bulkShipStreet: bulk_ship_street
        bulkShipApartment: bulk_ship_apartment
        bulkShipCountry: bulk_ship_country
        bulkShipStateProvince: bulk_ship_state_province
        bulkShipStateProvinceCode: bulk_ship_state_province_code
        bulkShipCity: bulk_ship_city
        bulkShipZipCode: bulk_ship_zip_code
        bulkShipPhone: bulk_ship_phone
      }
      fullCount
    }
  }
`

export const DeleteTeamStoreMutation = graphql(
  gql`
    mutation deleteTeamStore($id: String!) {
      deleteTeamStore(teamStoreId: $id) {
        message
      }
    }
  `,
  {
    name: 'deleteTeamStore'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyTeamStores/data.ts